import React, { useState } from 'react';
import { connect } from 'react-redux';
import { AppState } from '@Redux/store';
import { Dispatch } from '@Redux/type';
import { container } from '@Container';
import { TYPES } from '@Types';
import { DraftAction } from '@Redux/actions';
import CreateDraftForm from '@Components/draft/create/CreateDraftForm';
import CreateDraftTableForm from '@Components/draft/create/CreateDraftTableForm';
import { CreateDraftParams } from '@Components/draft/create/DraftValidate';
import { PairingStep } from './DraftPageNew.styled';
import SelectGameForm from '@Components/draft/create/SelectGameForm';

const CreateDraft: React.FC<CreateDraftProps> = ({handleSubmit}) => {
  const [step, setStep] = useState(0);
  const nextPage = () => {
    setStep(step + 1);
  }
  const previousPage = () => {
    setStep(step - 1);
  }

  let content = <SelectGameForm  onSubmit={nextPage}/>;
  if (step == 1) {
  content = <CreateDraftForm onSubmit={nextPage}/>;
  }
  else if (step == 2) {
    content = <CreateDraftTableForm onSubmit={handleSubmit} previousPage={previousPage}/>
  }

  return (
    <PairingStep className="text-center">
      {content}
    </PairingStep>
  );
};

const mapStateToProps = (_: AppState) => ({});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<DraftAction>(TYPES.Actions.Tool.DraftAction)
  return {
    handleSubmit: (values: CreateDraftParams) => {
      dispatch(action.create(values))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateDraft);

type CreateDraftProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
